var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7124 14.0612L14.8874 13.2363L15.7124 12.4113C16.8514 11.2723 16.8514 9.42559 15.7124 8.28656C14.5734 7.14753 12.7266 7.14753 11.5876 8.28656L10.7627 9.11152L9.9377 8.28656L10.7627 7.46161C12.3573 5.86696 14.9427 5.86696 16.5374 7.46161C18.132 9.05625 18.132 11.6417 16.5374 13.2363L15.7124 14.0612ZM14.0625 15.7112L13.2375 16.5361C11.6429 18.1308 9.05747 18.1308 7.46283 16.5361C5.86819 14.9415 5.86819 12.3561 7.46283 10.7614L8.28778 9.93648L9.11274 10.7614L8.28778 11.5864C7.14875 12.7254 7.14875 14.5722 8.28778 15.7112C9.42681 16.8502 11.2736 16.8502 12.4126 15.7112L13.2375 14.8862L14.0625 15.7112ZM13.65 9.524L14.4749 10.349L10.3502 14.4738L9.52522 13.6488L13.65 9.524Z",
    fill: "#8080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/link-white.b9c36df1dd72de3a26014b234b6f3728.svg";
export { ForwardRef as ReactComponent };